import { isEqual } from "lodash-es";
const formatAddressReturnToData = (address) => ({
  company: address.company,
  firstname: address.firstname,
  lastname: address.lastname,
  street: address.street[0],
  apartment: address.street[1],
  city: address.city,
  region: address.region.code,
  country_code: address.country.code,
  postcode: address.postcode,
  telephone: address.telephone
});
const addressFromApiToForm = (address) => {
  var _a, _b, _c, _d, _e;
  return {
    company: address.company,
    firstname: address.firstname,
    lastname: address.lastname,
    street: (_a = address.street) == null ? void 0 : _a[0],
    apartment: (_b = address.street) == null ? void 0 : _b[1],
    city: address.city,
    region: address.region ? (_d = (_c = address == null ? void 0 : address.region) == null ? void 0 : _c.region_code) != null ? _d : address.region.code : null,
    country_code: (_e = address == null ? void 0 : address.country_code) != null ? _e : address.country.code,
    postcode: address.postcode,
    telephone: address.telephone
  };
};
const getInitialCheckoutAddressForm = () => ({
  company: "",
  firstname: "",
  lastname: "",
  street: "",
  apartment: "",
  city: "",
  region: "",
  country_code: "",
  postcode: "",
  telephone: ""
});
const findUserAddressIdenticalToSavedCartAddress = (customerAddresses, cartAddress) => {
  var _a;
  return (_a = customerAddresses == null ? void 0 : customerAddresses.find(
    (userAddress) => isEqual(addressFromApiToForm(userAddress), addressFromApiToForm(cartAddress))
  )) != null ? _a : null;
};
export {
  addressFromApiToForm,
  findUserAddressIdenticalToSavedCartAddress,
  formatAddressReturnToData,
  getInitialCheckoutAddressForm
};
